import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { css } from "styled-components";
import { colors, fontVariant as fontVariantEnhancer, margins, paddingBottom, paddings, sizes, text, composeEnhancers } from "../../core/enhancers";
var composedEnhancer = composeEnhancers(fontVariantEnhancer, paddingBottom);
export var listStylesEnhancer = function listStylesEnhancer(_ref) {
  var size = _ref.size,
      theme = _ref.theme;
  var config = theme.componentsTokens.list.listSizes[size] || {};
  return css(["margin:0;padding:0;list-style:none;font-family:", ";color:", ";", ";", ";", ";", ";", ";", ";"], theme.font.fontFamily, theme.font.color, config.pb && css(["padding-bottom:", "px;"], config.pb), colors, sizes, text, margins, paddings);
};
export var listItemStylesEnhancer = function listItemStylesEnhancer(_ref2) {
  var size = _ref2.size,
      theme = _ref2.theme;
  var tokens = theme.componentsTokens.list;
  var _tokens$listItemSizes = tokens.listItemSizes[size],
      fontVariant = _tokens$listItemSizes.fontVariant,
      pb = _tokens$listItemSizes.pb;
  return css(["", ";", " ", ";", ";", ";"], composedEnhancer(_objectSpread({
    theme: theme,
    fontVariant: fontVariant
  }, pb && {
    pb: pb
  })), tokens.lineHeight && css(["&&{line-height:", ";}"], tokens.lineHeight), colors, text, paddings);
};